import { IconX } from '@tabler/icons-react'

import IconButton from 'shared/ui/IconButton'
import { addTestId } from 'shared/utils/tests'

import { useDrawerContext } from './DrawerContext'

import styles from './DrawerClose.module.scss'

type DrawerCloseProps = {
  closeButtonLabel?: string
}

export const DrawerClose = ({
  closeButtonLabel = 'Zamknij panel boczny'
}: DrawerCloseProps) => {
  const context = useDrawerContext()

  if (!context) {
    throw new Error('DrawerClose must be used inside a <Drawer> component.')
  }

  return (
    <IconButton
      className={styles.closeButton}
      size='medium'
      aria-label={closeButtonLabel}
      onClick={context.onClose}
      type='button'
      variant='transparent'
      {...addTestId('drawer-close-icon')}
    >
      <IconX />
    </IconButton>
  )
}

export default DrawerClose
